(function() { window.GUID_9836fb21_502f_4c42_b8ee_d3a016a40808 = { getGuid: function() { return "9836fb21-502f-4c42-b8ee-d3a016a40808"; } }; })();
var Portal;
(function (Portal) {
    $(function () {
        var eventType = $('#EventType').val();
        var listPortal = $('.PortalItemLink');
        //Cette partie est desuette et temporaire le temps que les vieux cookie disparaissent
        var lastClickedSportEventId = $.cookie('sporteventid');
        var lastSelectedItem = null;
        if (lastClickedSportEventId != null && lastClickedSportEventId != "") {
            lastSelectedItem = $(".PortalItemLink[data-sporteventid='" + lastClickedSportEventId + "']");
            if (lastSelectedItem != null) {
                $.removeCookie('sporteventid', { path: '/' });
                if (eventType == "League") {
                    $.cookie('lastleague', lastClickedSportEventId, { expires: 365, path: '/' });
                }
                else {
                    $.cookie('lasttournament', lastClickedSportEventId, { expires: 365, path: '/' });
                }
            }
        }
        //################################################
        if (lastSelectedItem == null) {
            if (eventType == "League") {
                lastClickedSportEventId = $.cookie('lastleague');
            }
            else {
                lastClickedSportEventId = $.cookie('lasttournament');
            }
            lastSelectedItem = $(".PortalItemLink[data-sporteventid='" + lastClickedSportEventId + "']");
        }
        if (lastSelectedItem != null && lastSelectedItem.length > 0) {
            FocusSportEventElement(lastSelectedItem.first());
        }
        listPortal.on('click', function (e) {
            var clickedSportEventId = $(this).data('sporteventid');
            if (clickedSportEventId != null && clickedSportEventId != "") {
                SetCookieEvent(eventType, clickedSportEventId);
            }
        });
        $('.ListPortal').on('click', '.PortalFavorite', function (e) {
            var favoriteIcon = $(this);
            var clickedSportEventId = favoriteIcon.parent('.PortalItem').find('.PortalItemLink').data('sporteventid');
            var data = { clickedSportEventId: clickedSportEventId };
            if (favoriteIcon[0].src.indexOf('YellowStar') > -1) {
                favoriteIcon[0].src = "/cdn/cs/images/base/yellowstar.png";
            }
            else {
                favoriteIcon[0].src = "/cdn/cs/images/base/graystar.png";
            }
            CompuSport.Ajax.Post(CSParameters.RUrl + "Portal/ToggleFavorite/" + CSParameters.SportEventId, data, function (response) {
                if (response.newState) {
                    favoriteIcon[0].src = "/cdn/cs/images/base/yellowstar.png";
                }
                else {
                    favoriteIcon[0].src = "/cdn/cs/images/base/graystar.png";
                }
            });
        });
        if (IsDefined(typeof (MasterPage.MasterSearch))) {
            MasterPage.MasterSearch.on('CSMasterSearch', function (e) {
                var val = MasterPage.MasterSearch.context();
                if (val != null) {
                    var sportEventId = val.id;
                    var eventType = 'League';
                    if (val.customClass.indexOf('IsLeague') == -1) {
                        eventType = 'Tournament';
                    }
                    SetCookieEvent(eventType, sportEventId);
                    window.location.href = CSParameters.BaseUrl + "GeneralSearch/Index/" + MasterPage.MasterSearch.val() + "?callFromHomePage=True";
                }
            });
        }
        $('#FilterBar').on('click', '.ToolBarButton', function () {
            var btn = $(this);
            var eventType = $('#EventType').val();
            $('#FilterBar .ToolBarButton').removeClass('Active');
            btn.addClass('Active');
            var data = {};
            data.section = btn.data('section');
            data.eventType = eventType;
            CompuSport.Ajax.Get(CSParameters.RUrl + "Portal/GetSection/" + CSParameters.SportEventId, data, function (response) {
                $('#ListPortal').html(response);
            });
        });
        $('#ListPortal').on('click', '.AssociationItem', function () {
            var eventType = $('#EventType').val();
            var btn = $('#FilterBar .ToolBarButton.Active');
            var data = {};
            data.section = btn.data('section');
            data.eventType = eventType;
            data.association = $(this).data('associationid');
            var association = $(this).find('.PortalItemTitle').text();
            CompuSport.Ajax.Get(CSParameters.RUrl + "Portal/GetSection/" + CSParameters.SportEventId, data, function (response) {
                $('#ListPortal').html(response);
                $('#FooterInfo').html('<p>' + association + '</p>');
            });
        });
        $('#ListPortal').on('click', '.HistoryItem', function () {
            var eventType = $('#EventType').val();
            var btn = $('#FilterBar .ToolBarButton.Active');
            var data = {};
            data.section = btn.data('section');
            data.eventType = eventType;
            data.specificYear = $(this).data('historyyear');
            CompuSport.Ajax.Get(CSParameters.RUrl + "Portal/GetSection/" + CSParameters.SportEventId, data, function (response) {
                $('#ListPortal').html(response);
                $('#FooterInfo').html('<p>' + data.specificYear + '</p>');
            });
        });
    });
    function SetCookieEvent(eventType, eventId) {
        if (eventType == "League") {
            $.removeCookie('lastleague', { path: '/' });
            $.cookie('lastleague', eventId, { expires: 365, path: '/' });
        }
        else {
            $.removeCookie('lasttournament', { path: '/' });
            $.cookie('lasttournament', eventId, { expires: 365, path: '/' });
        }
    }
    //aide a déboguer si des click ne fonctionne pas bien.
    //$(document).on('mousedown', function (e) {
    //    alert($(e.target).parent()[0].id + " & " + e.target.outerHTML);
    //});
    function FocusSportEventElement(element) {
        element.addClass('OverlayHighlighted');
        var portalItem = element.closest('.PortalItemContainer');
        var listPortalParent = portalItem.parent('.ListPortal');
        portalItem.detach().prependTo(listPortalParent);
    }
})(Portal || (Portal = {}));

//# sourceMappingURL=Portal.js.map
